import React, { memo, useEffect } from "react";
import Benchmarks from "../../Benchmarks";
import withRegras from "../../../hoc/withRegras";
import useKickBack from "../../../hooks/useKickBack";
import withMessage from "../../../hoc/withMessage";
const ReportSettingsBenchmarks = memo(props => {
  const kick = useKickBack();
  useEffect(() => {
    kick && props.onMessage("Entidade alterada");
  }, [kick]);
  return <Benchmarks />;
});
export default withRegras(withMessage(ReportSettingsBenchmarks));
